module.exports = __webpack_public_path__ + "static/media/prepaid-card-platinum-new-2021.549f76be.jpg";